/**
 * Razorpay loader + INR formatter — extracted from CheckoutDialog so the
 * dialog stays focused on UI and side-effects.
 */
const RAZORPAY_SCRIPT = "https://checkout.razorpay.com/v1/checkout.js";

export function formatINR(amount) {
  return `₹${Number(amount).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
}

/** Lazily loads the Razorpay Checkout script (once per page lifetime). */
export function loadRazorpay() {
  return new Promise((resolve, reject) => {
    if (window.Razorpay) return resolve(true);
    const existing = document.querySelector(`script[src="${RAZORPAY_SCRIPT}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve(true), { once: true });
      existing.addEventListener("error", () => reject(new Error("Razorpay script failed to load.")), { once: true });
      return;
    }
    const s = document.createElement("script");
    s.src = RAZORPAY_SCRIPT;
    s.async = true;
    s.onload = () => resolve(true);
    s.onerror = () => reject(new Error("Razorpay script failed to load."));
    document.body.appendChild(s);
  });
}
